var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareArrowOutUpRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-icon/square-arrow-out-up-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.25 10.25V14.75C16.25 15.1478 16.092 15.5294 15.8107 15.8107C15.5294 16.092 15.1478 16.25 14.75 16.25H4.25C3.85218 16.25 3.47064 16.092 3.18934 15.8107C2.90804 15.5294 2.75 15.1478 2.75 14.75V4.25C2.75 3.85218 2.90804 3.47064 3.18934 3.18934C3.47064 2.90804 3.85218 2.75 4.25 2.75H8.75",
    stroke: "#3333FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.25 2.75L9.5 9.5",
    stroke: "#3333FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 2.75H16.25V7.25",
    fill: "#2649D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 2.75H16.25V7.25",
    stroke: "#3333FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareArrowOutUpRightBlue);
export default __webpack_public_path__ + "static/media/square-arrow-out-up-right-blue.b7feb9c569f1d911bc3ffdddca6e1664.svg";
export { ForwardRef as ReactComponent };